<template>
  <div>
    <PackagesManagerOrdersGeneratorList1D />
  </div>
</template>

<script>
import PackagesManagerOrdersGeneratorList1D from "./PackagesManagerOrdersGeneratorList1D.vue";
import {usePackagesManagerModule} from "@/state/pinia/packagesManagerModule";
import {useSimplepharmAuthModule} from "@/state/pinia/simplepharmAuthModule";
import {useCommonAppModule} from "@/state/pinia/commonAppModule";
import {useLazyLoaderModule} from "@/state/pinia/lazyloaderManagerModule";

export default {
  name: "PackagesManagerOrdersGeneratorStage",
  components: {PackagesManagerOrdersGeneratorList1D },
  computed: {
    packagesModule(){
      return usePackagesManagerModule();
    },
    simplepharmAuth(){
      return useSimplepharmAuthModule();
    },
    commonModule(){
      return useCommonAppModule();
    },
    lazyloaderModule(){
      return useLazyLoaderModule();
    },
  },
  methods: {

  },
  watch: {
  },
  created() {
    this.simplepharmAuth.refreshToken().then(() => {
      this.commonModule.httpGetLicensedFeatures();
      this.commonModule.httpGetWorkingProfile();

    });

  },
};
</script>

<style scoped>
.package-orders-stage {
  height: 1920px;
  background: #fafafa;
  margin-left: 16px;
  margin-right: 16px;

}
</style>
